import { createContext } from "react";

export const JWTContext = createContext({
	JWT: {},
	setJWT: () => {},
});
